import { render, staticRenderFns } from "./Header copy 2.vue?vue&type=template&id=f225a152&scoped=true"
import script from "./Header copy 2.vue?vue&type=script&lang=js"
export * from "./Header copy 2.vue?vue&type=script&lang=js"
import style0 from "./Header copy 2.vue?vue&type=style&index=0&id=f225a152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f225a152",
  null
  
)

export default component.exports